/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_CompareInputs */

const cs_pm_compare = /** @type {(inputs: Pm_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porovnání`)
};

const en_pm_compare = /** @type {(inputs: Pm_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparison`)
};

/**
* | output |
* | --- |
* | "Comparison" |
*
* @param {Pm_CompareInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_compare = /** @type {((inputs?: Pm_CompareInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_CompareInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_compare(inputs)
	return cs_pm_compare(inputs)
});